export { Banner } from './Banner';
export type { BannerProps, Variants } from './Banner';
export { bannerData } from './content';
